/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-09-29 18:04:27
 * @LastEditors: shenlin
 * @LastEditTime: 2021-12-14 15:19:30
 */
/* ------------------------------------积分模块----------------------------------------*/
/* ------------------------------------积分明细管理-积分明细----------------------------------------*/
/**
 * 积分变动选项
 */
export const pointsChangeType = [{
  label: '全部',
  value: ''
}, {
  label: '获取',
  value: 0
}, {
  label: '消费',
  value: 1
}]
export const pointsPointType = [{
  label: '全部',
  value: ''
}, {
  label: '自动',
  value: 0
}, {
  label: '人工',
  value: 1
}]
// wEditor文本编辑器的默认配置项
import { getToken } from '@utils'
// import { uploadFileUrlGov } from '@api/commonApi'
import { uploadImg } from '@api/video/liveOperation'
export const wEditorDefaultConfig = {
  indent_size: 2,
  pasteFilterStyle: false,
  pasteIgnoreImg: true, // 忽略复制粘贴图片
  showLinkImg: false, // 隐藏网络图片tab
  uploadVideoServer: uploadImg, // 上传视频地址
  uploadImgServer: uploadImg, // 上传图片地址
  uploadFileName: 'file', // 上传的文件参数名字
  // 设置上传图片请求头
  uploadImgHeaders: {
    Authorization: 'Bearer ' + getToken()
  },
  // 设置上传视频请求头
  uploadVideoHeaders: {
    Authorization: 'Bearer ' + getToken()
  },
  menus: [
    'head',
    'bold',
    'fontSize',
    'fontName',
    'italic',
    'underline',
    'strikeThrough',
    'indent',
    'lineHeight',
    'foreColor',
    'backColor',
    'link',
    'list',
    'todo',
    'justify',
    'quote',
    'emoticon',
    'image',
    'video',
    'table',
    'code',
    'splitLine',
    'undo',
    'redo'
  ],
  zIndex: 0// 配置编辑区域的 z-index
}
